import dynamic from "next/dynamic";
// const Markdown = dynamic(() => import("markdown-to-jsx"));
import LinkListSection from "components/content/LinkList/LinkListSection";
import Markdown from "markdown-to-jsx";
const AffiliateBlock = dynamic(
  () => import("components/Affiliates/AffiliateBlock")
);
// const LinkListSection = dynamic(() =>
//   import("components/content/LinkList/LinkListSection")
// );
import styles from "./InformationSection.module.scss";

export default function InformationSection({
  information = null,
  affiliates,
  linkSections,
  list,
  icon,
  column1ChildrenBefore,
  column2ChildrenBefore,
}) {
  const category = information?.category;
  const text = information?.text;

  const linkListSections =
    linkSections?.map((linkSection, index) => (
      <LinkListSection
        linkSection={linkSection}
        key={`${linkSection.name}-${index}`}
      />
    )) ?? null;

  const listItems = list?.list_item?.map((item) => (
    <li key={item.id}>
      <h3>{item.title}</h3>
      <Markdown>{item.description}</Markdown>
    </li>
  ));

  return (
    <article className={`${styles.container} text-container`}>
      <div className={`${styles.content} markdown-section`}>
        {column1ChildrenBefore && (
          <div className={`${styles.column1ChildrenBefore}`}>
            {column1ChildrenBefore}
          </div>
        )}
        {text && <Markdown className={`${styles.text}`}>{text}</Markdown>}
        {linkListSections && linkListSections}
        {list && list?.list_type === "unordered" && <ul>{listItems}</ul>}
        {list && list?.list_type === "ordered" && <ol>{listItems}</ol>}
      </div>
      {(!!affiliates?.length || !!column2ChildrenBefore) && (
        <div
          className={`${styles.sidebar} ${
            !!affiliates.length ? styles.affiliates : ""
          }`}
        >
          {column2ChildrenBefore && (
            <div className={`${styles.column2ChildrenBefore}`}>
              {column2ChildrenBefore}
            </div>
          )}
          {!!affiliates.length &&
            affiliates.map((affiliate) => (
              <AffiliateBlock
                affiliate={affiliate}
                key={`${affiliate.anchor_text}`}
              />
            ))}

          {icon && !affiliates.length && (
            <span className={`${styles.icon}`}>{icon}</span>
          )}
        </div>
      )}
    </article>
  );
}
